import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tile, InternalImage, PlayButton, HoverOverlay, } from "../GameTilesGrid/GameTilesGrid.styled";
import { CustomThumbnail } from "../CustomThumbnail";
import { Container } from "./GameTile.styled";
import GameTilePlayIcon from "./GameTile.play";
var GameTile = function (_a) {
    var game = _a.game, onClick = _a.onClick;
    var handleGameClick = function () {
        onClick(game);
    };
    return (_jsx(Container, { children: _jsxs(Tile, { onClick: handleGameClick, children: [game.customThumb && (_jsx(InternalImage, { src: game.urlThumb, alt: game.label })), !(game === null || game === void 0 ? void 0 : game.customThumb) && (_jsx(CustomThumbnail, { imageUrl: game.urlThumb, title: game.label, provider: game.provider })), _jsx(HoverOverlay, { children: _jsx(PlayButton, { children: _jsx(GameTilePlayIcon, {}) }) })] }) }));
};
export default GameTile;
//# sourceMappingURL=GameTile.js.map